<template>
  <nav class="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 pb-safe">
    <div class="flex max-w-3xl mx-auto">
      <router-link
        to="/home"
        class="flex-1 flex flex-col items-center gap-1 py-3 transition-colors"
        :class="$route.path === '/home' ? 'text-blue-600' : 'text-gray-400 active:text-gray-500'"
      >
        <i class="fas fa-route text-xl"></i>
        <span class="text-xs font-semibold">Route</span>
      </router-link>
      <router-link
        to="/deliver"
        class="flex-1 flex flex-col items-center gap-1 py-3 transition-colors"
        :class="$route.path === '/deliver' ? 'text-amber-600' : 'text-gray-400 active:text-gray-500'"
      >
        <i class="fas fa-warehouse text-xl"></i>
        <span class="text-xs font-semibold">Deliver</span>
      </router-link>
    </div>
  </nav>
</template>

<style scoped>
.pb-safe {
  padding-bottom: env(safe-area-inset-bottom);
}

@supports not (padding: env(safe-area-inset-bottom)) {
  .pb-safe {
    padding-bottom: 0;
  }
}
</style>
